module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "filter-date",
    attrs: {
      "id": "filterdate"
    }
  }, [_c('FilterDatePreset', {
    attrs: {
      "default-option": this.defaultOption
    }
  }), _vm._v(" "), _c('FilterDateRange'), _vm._v(" "), _c('div', {
    staticClass: "filter-date-toggle"
  }, [_c('a', {
    on: {
      "click": function($event) {
        return _vm.toggleDateFilter()
      }
    }
  }, [_vm._v(_vm._s(_vm.dateToggleLabel))])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-d561dbf0"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/FilterDate.vue
// module id = 453
// module chunks = 1